import gql from 'graphql-tag';

import type { FeedAssetGroup } from 'src/data/project';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationPromoteLowerScoringAssetsArgs } from 'src/types/backend';

import { FRAGMENT_ASSET_GROUP } from './schema';

type Variables = BackendMutationPromoteLowerScoringAssetsArgs;

// Unlike a retry, this one is answered in place: the candidates already exist, so the group comes
// back with them attached rather than through a job.
const MUTATION = gql`
  mutation PromoteLowerScoringAssets($variationId: ID!, $recomposeRequestId: ID!) {
    promoteLowerScoringAssets(variationId: $variationId, recomposeRequestId: $recomposeRequestId) {
      ...AssetGroupFields
    }
  }
  ${FRAGMENT_ASSET_GROUP}
`;

export const promoteLowerScoringAssets = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<FeedAssetGroup | null>(result.data);
};
